import React from "react";
import whitelogo from "../../../images/logo/logo-navbar.png";
import { Link } from "react-router-dom";
import navbarData from "../../../data/navbar.json";
import footerData from "../../../data/footer.json";

export default function Footer({ space }) {
  return (
    <>
      <footer className="footer-section">
        <div
          className={`footer-top background-img-2 ${
            space ? "pt-150" : "pt-60"
          }`}
          style={{
            backgroundImage:
              "linear-gradient(to right, var(--color-76), var(--color-81), var(--color-86), var(--color-63), var(--color-67))",
          }}
        >
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-sm-12 col-md-4">
                <div className="footer-nav-wrap text-white">
                  <img
                    src={whitelogo}
                    alt="footer logo"
                    width="200"
                    className="img-fluid mb-3"
                  />
                  <p>{footerData.description}</p>
                </div>
              </div>
              
              
              <div className="col-sm-12 col-md-3 col-lg-2">
                <div className="footer-nav-wrap text-white">
                  <h5 className="mb-3 text-white">Company</h5>
                  <ul className="list-unstyled support-list">
                    {navbarData.map((data) => (
                      <li key={data.id} className="mb-2">
                        <Link to={data.link}>{data.name}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>


              <div className="col-sm-12 col-md-4 col-lg-3">
                <div className="footer-nav-wrap text-white">
                  <h5 className="mb-3 text-white">Location</h5>
                  <ul className="list-unstyled support-list">
                    <li className="mb-2 d-flex align-items-center">
                      <span className="ti-location-pin mr-2"></span>
                      {footerData.location}
                      <br />
                      {footerData.state}
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span className="ti-mobile mr-2"></span>
                      {footerData.phone}
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span className="ti-email mr-2"></span>
                      {footerData.email}
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span className="ti-world mr-2"></span>
                      {footerData.website}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom border-gray-light mt-5 py-3">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-lg-7">
                  <div className="copyright-wrap small-text">
                    <p className="mb-0 text-white">© BM Consulting</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-5">
                  {/* <div className="terms-policy-wrap text-lg-right text-md-right text-left">
                    <ul className="list-inline">
                      <li className="list-inline-item">
                        <a className="small-text" href="#/">
                          Terms
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="small-text" href="#/">
                          Security
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="small-text" href="#/">
                          Privacy Policy
                        </a>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
